import { render, staticRenderFns } from "./Manufacturing.vue?vue&type=template&id=3a06df18&scoped=true"
import script from "./Manufacturing.vue?vue&type=script&lang=js"
export * from "./Manufacturing.vue?vue&type=script&lang=js"
import style0 from "./Manufacturing.vue?vue&type=style&index=0&id=3a06df18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a06df18",
  null
  
)

export default component.exports